
import {throwError as observableThrowError,  Observable } from 'rxjs';

import {catchError, map} from 'rxjs/operators';
import { Injectable } from "@angular/core";
import { Response } from "@angular/http";
import { HttpClientService } from "./httpclient";
import { Sms } from '../models/sms/sms.interface';
import { environment } from '../../../environments/environment';
@Injectable()
export class SmsService {
    constructor(
        private readonly http: HttpClientService,
      ) { }

  public send(transportOrderNumber: string, depotInPlanningBlockIds: number[], depotOutPlanningBlockIds: number[],
    depotInTextMessage: string, depotOutTextMessage: string, userId: string) {

    return this.http.post(environment.ContainerPlanningApiUri +
          "sms/send/", {
          transportOrderNumber,
          depotInPlanningBlockIds,
          depotOutPlanningBlockIds,
          depotInTextMessage,
          depotOutTextMessage,
          userId,
          }).pipe(
          map((response: any) => {
            return response.data;
          }),
          catchError((err) => {
            return observableThrowError(err);
          }),);
      }

  public getTextMessage(transportOrderNumber: string, depotInPlanningBlockIds: number[],
    depotOutPlanningBlockIds: number[]): Observable<Sms> {
        return this.http.post(environment.ContainerPlanningApiUri +
            "sms/text-message/", {
          transportOrderNumber:transportOrderNumber,
              depotInPlanningBlockIds:depotInPlanningBlockIds,
              depotOutPlanningBlockIds: depotOutPlanningBlockIds,
              
            }).pipe(
            map((response: any) => {
              return response.data;
            }),
            catchError((err) => {
              return observableThrowError(err);
            }),);
      }
}
